module.exports = __webpack_public_path__ + "static/header3-258e5202a6f46b85a5bcbbe20c185bca.jpg";